<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted() {
    window.addEventListener('offline', (e) => {
      this.$toast.bottom('Network error!.');
    });

    window.addEventListener('online', (e) => {
      setTimeout(
        (t) => {
          this.$toast.bottom('Connected to network!');
        },
        1000,
        this
      );
    });
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  border: none;
}
</style>
